export const rails = [
    {
        name: 'gr_65',
        height: 0.1,
        width: 0.65,
        depth: 0.1,
    },
    {
        name: 'gr_95',
        height: 0.1,
        width: 0.95,
        depth: 0.1,
    },
    {
        name: 'gr_125',
        height: 0.1,
        width: 1.25,
        depth: 0.1,
    },
];

export const defaultRailsOffsets = [ 0,0,0 ] as const;